import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-950">Questa pagina non esiste</h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">Torna alla homepage per continuare a navigare</p>
        <a
          href="/"
          className="mt-8 inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-md font-label text-sm hover:bg-primary-600 transition-all cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          Torna alla Home
        </a>
      </div>
    </div>
  );
}